import React from 'react'
import { TextField } from '@fluentui/react/lib/TextField'
import { Dropdown, MaskedTextField } from '@fluentui/react'
import PropTypes from 'prop-types'
import { toast } from 'helperLibraries/index'
import _ from 'lodash'
import ModalComponent from '../ModalComponent'
import './index.css'
import * as yup from 'yup'
import 'yup-phone'
import { validateName } from '../../../helperLibraries'

let schema = yup.object().shape({
  firstName: yup
    .string()
    .required()
    .label('First Name')
    .test(
      'alphabets',
      'First Name must only contain letters',
      (value) => {
        return validateName(value)
      },
    ),
  lastName: yup
    .string()
    .required()
    .label('Last Name')
    .test(
      'alphabets',
      'Last Name must only contain letters',
      (value) => {
        return validateName(value)
      },
    ),

  phoneNumberCell: yup
    .string()
    .phone('US')
    .required()
    .label('Phone Number'),
})

const validateForm = (formValues) => {
  try {
    return schema.validateSync(formValues, { abortEarly: false })
  } catch (e) {
    e.inner.reverse().forEach((e) => toast.error(e.message))
  }
}

const submitAndValidate = async (formValues, submitFunc) => {
  if (!validateForm(formValues)) return
  try {
    await submitFunc()
  } catch (e) {
    console.error(e)
    if (
      e.response?.data?.error?.message ===
      'phoneNumberCell must be unique'
    ) {
      toast.error(
        'Error saving contact. Phone number must be unique. This phone number is already stored',
      )
    } else {
      toast.error(
        'Error saving contact. Please try again. If the problem persists, please contact the ResiDesk team at support@theresidesk.com',
      )
    }
  }
}

const serializePortfolioDataForPicker = (portfolio) => ({
  key: portfolio.id,
  text: portfolio.name,
})

const PortfolioPicker = ({
  portfolios,
  onChangePortfolioPicker,
  portfolioId,
}) => (
  <Dropdown
    data-cy="people_form_select_portfolio"
    label="Community"
    placeholder="e.g. East Region"
    selectedKey={portfolioId || undefined}
    onChange={onChangePortfolioPicker}
    options={portfolios.map(serializePortfolioDataForPicker)}
  />
)

export const transformPhoneNumberCell = (phoneNumberCell) => {
  let value = _.trimStart(phoneNumberCell, '+1')
  console.log(value, phoneNumberCell)
  if (value === phoneNumberCell) {
    value = _.trimStart(value, '1')
  }
  console.log(value, phoneNumberCell)
  return value
}

const PeopleFormModal = ({
  isLoading = false,
  formValues,
  onChangeForm,
  visible,
  onCloseFunc,
  onSubmitFunc,
  peopleType,
  lastFieldFocus,
  portfolios,
  onChangePortfolioPicker,
  portfolioId,
  headerTitle,
  showPortfolioPicker,
}) => {
  const ModalBody = () => (
    <div className="new-maintenance-form-container">
      <div className="text-input-container">
        <TextField
          data-cy="people_form_firstname"
          label="First Name"
          placeholder="e.g. Alex"
          onChange={onChangeForm('firstName')}
          value={formValues.firstName}
          autoFocus={lastFieldFocus === 'firstName'}
        />
      </div>
      <div className="text-input-container">
        <TextField
          data-cy="people_form_lastname"
          label="Last Name"
          placeholder="e.g. Smith"
          onChange={onChangeForm('lastName')}
          value={formValues.lastName}
          autoFocus={lastFieldFocus === 'lastName'}
        />
      </div>
      <div className="text-input-container">
        <TextField
          data-cy="people_form_cell"
          label="Cell Phone Number"
          onChange={onChangeForm('phoneNumberCell')}
          value={transformPhoneNumberCell(formValues.phoneNumberCell)}
          autoFocus={lastFieldFocus === 'phoneNumberCell'}
        />
        <MaskedTextField
          data-cy="people_form_cell"
          mask="(999) 999-9999"
          value={transformPhoneNumberCell(formValues.phoneNumberCell)}
          disabled={true}
        />
      </div>
      <div className="text-input-container">
        <TextField
          data-cy="people_form_email"
          label="Email"
          placeholder="e.g. alex@gmail.com"
          onChange={onChangeForm('email')}
          value={formValues.email}
          autoFocus={lastFieldFocus === 'email'}
        />
      </div>
      {showPortfolioPicker && (
        <div className="text-input-container">
          <PortfolioPicker
            portfolios={portfolios}
            onChangePortfolioPicker={onChangePortfolioPicker}
            portfolioId={portfolioId}
          />
        </div>
      )}
    </div>
  )

  return (
    <ModalComponent
      open={visible}
      headerTitle={headerTitle}
      closeModalEvent={onCloseFunc}
      closeText="Cancel"
      nextText={`Save ${formValues.firstName}`}
      nextModalEvent={() =>
        submitAndValidate(formValues, onSubmitFunc)
      }
      content={<ModalBody />}
      nextDisabled={false}
      isLoading={isLoading}
    />
  )
}

PeopleFormModal.propTypes = {
  formValues: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phoneNumberCell: PropTypes.string.isRequired,
  }).isRequired,
  lastFieldFocus: PropTypes.string,
  onChangeForm: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
}

PeopleFormModal.defaultProps = {
  lastFieldFocus: 'firstName',
}

export default PeopleFormModal
